'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
// Root Owner    Permissions Save    Write   Read
// Z     O        P           S       W       R
var ACCESS_BITS = exports.ACCESS_BITS = {
    READ: 1,
    WRITE: 1 << 1,
    SAVE: 1 << 2,
    PERMISSIONS: 1 << 3,
    OWNER: 1 << 4
};

var PERMISSION_STATES = exports.PERMISSION_STATES = {
    VALID: 'VALID',
    INVALID: 'INVALID',
    UNKNOWN: 'UNKNOWN'
};


//////////////////
// WEBPACK FOOTER
// ./src/common/permissions/permissionConstants.js
// module id = 485
// module chunks = 0